import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const Success = () => {
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  useEffect(() => {
   
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        cambio: obtenerLabelEtiqueta(
          "lbl_succesPass_msj_cambio",
          listadoEtiquetas
        ),

        volver_inicio: obtenerLabelEtiqueta(
          "lbl_global_msj_volver_inicio",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const { cambio, volver_inicio } = etiquetas;

  return (
    <div className="login-content va-middle">
      <div className="center">
        <div className="success-animation">
          <svg
            className="checkmark-animation"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
          >
            <circle
              className="checkmark__circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              className="checkmark__check"
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>

        <div className="log-title my-4">
          <h1
            className="title-success"
            style={{ marginLeft: "85px", marginRight: "85px" }}
          >
            {cambio}
             
          </h1>

          
        </div>

        <div className="text-center mt-5">
          <button type="submit" className="btn btn-send btn-250 mb-3">
            <Link to="auth" className="text-white text-decoration-none fs-6 ">
              {volver_inicio}
            </Link>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Success;
